import React, { useContext, useEffect, useState } from "react";

// react-bootstrap components
import { Button, Col, Dropdown, Nav, Tab } from "react-bootstrap";
import moment from "moment";
import DateRangeContext from "contexts/DateRangeContext";
import DatetimeSelect from "components/Custom/DatetimeSelect";
import { apiService } from "service/ApiService";
import StoreContext from "contexts/StoreContext";
import { serverTimesampToNormalDate } from "utils/AppUtils";

import { useTranslation } from "react-i18next";

function HipposFixedPlugin() {
  const {
    t,
  } = useTranslation();

  const [fromDateTime, setFromDateTime] = useState(moment().startOf("day").format("YYYY-MM-DD HH:mm:ss"));
  const [toDateTime, setToDateTime] = useState(moment().endOf("day").format("YYYY-MM-DD HH:mm:ss"));
  const [fromDate, setFromDate] = useState(moment().startOf("day").format("YYYY-MM-DD"));
  const [toDate, setToDate] = useState(moment().endOf("day").format("YYYY-MM-DD"));
  const [isDateSearch, setIsDateSearch] = useState(true);
  const { dateRange, setDateRange } = useContext(DateRangeContext);
  const { storeId, setStoreId } = useContext(StoreContext);

  const setDatetimeSearch = () => {
    setIsDateSearch(false);
    console.log(`Date Range:`, [fromDateTime, toDateTime]);
    setDateRange([fromDateTime, toDateTime]);
    clickToggle();
  };

  const setDateSearch = async (triggerClick = true) => {
    try {
      setIsDateSearch(true);
      const fromResponse = await apiService.post(`api/v1/day-closures/store/${storeId}/search-by-date`, {
        sort: "ASC",
        day_closure_date: fromDate,
      });

      const toResponse = await apiService.post(`api/v1/day-closures/store/${storeId}/search-by-date`, {
        sort: "DESC",
        day_closure_date: toDate,
      });
      const rawFromDate = serverTimesampToNormalDate(fromResponse.openedAt, "YYYY-MM-DD HH:mm:ss");
      let rawToDate;
      if (toResponse.active === true) rawToDate = moment().format("YYYY-MM-DD HH:mm:ss");
      else rawToDate = serverTimesampToNormalDate(toResponse.closureDatetime, "YYYY-MM-DD HH:mm:ss");
      console.log(`Date Range:`, [rawFromDate, rawToDate]);
      setDateRange([rawFromDate, rawToDate]);
      if (triggerClick) clickToggle();
    } catch (error) {
      console.error(error);
    }
  };

  const clickToggle = () => {
    const clockComponent = document.getElementById("dropdown-toggle");
    if (!clockComponent) return;
    clockComponent.click();
  };

  useEffect(() => {
    if (!storeId || !isDateSearch || apiService.isBackoffice()) return;
    setDateSearch(false);
  }, [storeId]);

  return (
    <>
      <div className="fixed-plugin">
        <Dropdown className="show-dropdown">
          <Dropdown.Toggle id="dropdown-toggle">
            <i className="fas fa-clock fa-2x"></i>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Tab.Container id="icons-tabs-example" defaultActiveKey="info-icons">
              <Nav role="tablist" variant="tabs">
                <Nav.Item>
                  <Nav.Link eventKey="info-icons">
                    <i className="fas fa-calendar"></i>{t("common.labels.byClosure")}</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="account-icons">
                    <i className="fas fa-circle"></i>{t("common.labels.byHour")}</Nav.Link>
                </Nav.Item>
              </Nav>
              <Tab.Content>
                <Tab.Pane eventKey="info-icons">
                  <Col md="12" sm="12">
                    <DatetimeSelect
                      title={t("common.labels.from")}
                      handler={setFromDate}
                      value={moment().startOf("day")}
                      timeFormat={false}
                      returnFormat={"YYYY-MM-DD"}
                    />
                  </Col>
                  <Col md="12" sm="12">
                    <DatetimeSelect title={t("common.labels.to")} handler={setToDate} value={moment().endOf("day")} timeFormat={false} returnFormat={"YYYY-MM-DD"} />
                  </Col>
                  <Col md="12" sm="12">
                    <Button className="btn-wd btn-outline mr-1" variant="success" onClick={setDateSearch} style={{ width: "100%" }}>
                      <div>
                        <i className="fa fa-calendar" />
                        <span>{t("common.labels.apply")}</span>
                      </div>
                    </Button>
                  </Col>
                </Tab.Pane>
                <Tab.Pane eventKey="account-icons">
                  <Col md="12" sm="12">
                    <DatetimeSelect title={t("common.labels.from")} handler={setFromDateTime} value={moment().startOf("day")} returnFormat={"YYYY-MM-DD HH:mm:ss"} />
                  </Col>
                  <Col md="12" sm="12">
                    <DatetimeSelect title={t("common.labels.to")} handler={setToDateTime} value={moment().endOf("day")} returnFormat={"YYYY-MM-DD HH:mm:ss"} />
                  </Col>
                  <Col md="12" sm="12">
                    <Button className="btn-wd btn-outline mr-1" variant="success" onClick={setDatetimeSearch} style={{ width: "100%" }}>
                      <div>
                        <i className="fa fa-circle" />
                        <span>{t("common.labels.apply")}</span>
                      </div>
                    </Button>
                  </Col>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </>
  );
}

export default HipposFixedPlugin;
